<template>
    <div class="box box-pack-between main">
        <sort-label-show title="分类标签展示：" topTitle="分类" :list="treeList" @nodeClick="getNodeIds"
            @handleDragEnd="handleDragEnd" @createTag="createTagEvent" @delLabel="delLabel"
            ref="sortLabel"></sort-label-show>
        <div class="flex1">
            <div class="mr-title" style="font-size: 18px;padding-left: 17px;">分类下的内容展示：</div>
            <div class="whiteBg height100 main-right">
                <el-select v-model="sortVal" @change="changeSort" placeholder="请选择类型">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <dy-table :columns="columns" style="margin-top: 12px;" :table-data="tableData" ref="table"
                    v-loading="tableLoading" :total="total" :page-num="currentPage" :page-size="10"
                    @current-change="onCurrentChange" element-loading-text="加载中"></dy-table>
            </div>
        </div>
    </div>
</template>
<script>
import DyTable from '@/components/common/dytable'
import sortLabelShow from '@/components/common/sortLabelShow/questionIndex';

import { zgAddCategory, zgDeleteCategory } from '@/api/index';
import { examSelectList, zgsourceAllCategory,paperList } from '@/api/index2';
import { encrypt, decrypt } from '@/api/common_encrypt';
import { formatDate } from '@/utils/utils';

var that = null;
export default {
    data() {
        return {
            tableLoading: false,
            columns: [
                {
                    key: 'name',
                    title: '类型名称'
                },
                {
                    key: 'categoryName',
                    title: '类型'
                },
                {
                    key: 'bgUserName',
                    title: '创建人'
                },
                {
                    key: 'updateDate',
                    title: '创建时间'
                }
            ],
            tableData: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            treeList: [],
            sortVal: '1',
            options: [
                {
                    value: '1',
                    label: '试卷'
                },
                {
                    value: '2',
                    label: '考试'
                },
                {
                    value: '3',
                    label: '练习'
                }
            ],
        }
    },
    components: {
        sortLabelShow,
        DyTable
    },
    mounted() {
        that = this;
        that.getCategory();
        that.getPaperList();
    },
    methods: {
        changeSort(e) {
            console.log(e);
            that.sortVal = e;
            that.currentPage = 1;
            switch (parseInt(e)) {
                case 1://试卷
                    that.getPaperList();
                    break;
                case 2://考试
                    that.examSelectList();
                    break;
                case 3://练习
                    that.examSelectList();
                    break;
            }
        },
        //节点拖动
        handleDragEnd(draggingNode, dropNode) {
            console.log('节点拖动', draggingNode.label, dropNode.label);
            that.saveClassification(draggingNode.data.value, draggingNode.data.label, dropNode.data.value);
        },
        //节点点击
        getNodeIds(id) {
            console.log(id);
            that.categoryId = id;
            that.changeSort(that.sortVal);
        },
        //切换页面
        onCurrentChange(val) {
            that.currentPage = val;
            switch (parseInt(that.sortVal)) {
                case 1://试卷
                    that.getPaperList();
                    break;
                case 2://考试
                    that.examSelectList();
                    break;
                case 3://练习
                    that.examSelectList();
                    break;
            }
        },
        // 创建标签
        createTagEvent(obj) {
            that.saveClassification(obj.id, obj.name, obj.parentId);
        },
        //删除标签
        delLabel(id) {
            console.log('删除标签', id);
            that.$confirm('确认要删除此标签吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let info = {
                    id,//分类id
                    type: 3
                };
                var data = encrypt(JSON.stringify(info));
                zgDeleteCategory(data).then((res) => {
                    that.$message({
                        showClose: true,
                        message: '删除成功',
                        type: 'success'
                    });
                    that.getCategory();
                });
            })
        },
        // 添加/修改分类
        saveClassification(id, name, parentId) {
            console.log('before', id, name, parentId);
            parentId = id == parentId ? 0 : parentId;
            let info = {
                id,//分类id
                name,//分类名称
                parentId,//父节点ID
                type: 3
            };
            var data = encrypt(JSON.stringify(info));
            zgAddCategory(data).then((res) => {
                if (res.result == 1) {
                    that.$refs.sortLabel.closeDialog();
                    that.$message({
                        showClose: true,
                        message: '操作成功',
                        type: 'success'
                    });
                    that.getCategory();
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        getPaperList() {
            let param = {
                name: '',
                categoryId: that.categoryId || '',
                publishStatus: 1,
                page: that.currentPage,
                pageSize: that.pageSize,
                needPage: true,
            };
            console.log('param :>> ', param);
            paperList(param).then((res) => {
                if (res.result == 1) {
                    that.tableData = res.data.list.map(item => {
                        return {
                            ...item,
                            name: item.paperName,
                            bgUserName: item.creatorName,
                            updateDate: formatDate(new Date(item.createTime), 'yyyy-MM-dd hh:mm'),
                        }
                    });
                    that.total = res.data.total;
                    that.tableLoading = false;
                } else {
                    console.log('error11');
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        //获取列表
        examSelectList() {
            let info = {
                name: '',
                categoryId: that.categoryId || '',
                beginTime: null,
                endTime: null,
                type: that.sortVal - 3 == 0?1:2,
                page: that.currentPage,
                pageSize: that.pageSize,
                needPage: true,
            };
            console.log(info);
            examSelectList(info).then((res) => {
                console.log('获取列表', res);
                if (res.result == 1) {
                    that.tableData = res.data.list.map(item => {
                        return {
                            ...item,
                            updateDate: formatDate(new Date(item.updateDate), 'yyyy-MM-dd hh:mm'),
                        }
                    });
                    that.total = res.data.total;
                    that.tableLoading = false;
                } else {
                    that.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    });
                }
            });
        },
        //获取所有分类(树型结构)
        getCategory() {
            let param = {
                type: 3,
            }
            zgsourceAllCategory(param).then((res) => {
                if (res.result == 1) {
                    console.log('考试分类', res);
                    const list = [{ name: '所有分类', id: '' }, ...res.data];
                    that.treeList = that.listFor(list);
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error',
                    });
                }
            });
        },
        listFor(arr) {
            let children = [];
            if (arr != null && arr != '' && arr != undefined) {
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].childCourseCategory != '' && arr[i].childCourseCategory != null && arr[i].childCourseCategory != undefined) {
                        children.push({
                            value: arr[i].id,
                            label: arr[i].name,
                            children: this.listFor(arr[i].childCourseCategory),
                        });
                    } else {
                        children.push({
                            value: arr[i].id,
                            label: arr[i].name,
                            children: this.listFor(arr[i].childCourseCategory),
                        });
                    }
                }
            } else {
                return;
            }
            return children;
        },
    }
}
</script>
<style lang="scss" scoped>
.main {
    padding: 17px;

    .main-right {
        flex: 1;
        overflow: hidden;
        margin-left: 16px;
        padding: 24px;
        overflow-y: scroll;
        margin-top: 12px;
    }
}
</style>